<template>
  <div class="feature">
    <div class="buttons has-addons">
      <span @click="applyClass(feature_type.id)" class="is-small feature_type_name">
        <i class="fa fa-circle" :style="{'color':feature_type.properties.color}"></i>
      </span>
      <span
        @click="toggleFeatures(feature_type.id)"
        class="class_name is-small is-capitalized is-rounded is-regular-16-000-42"
        :class="{'active':isActive}"
        v-tooltip="feature_type.name"
      >
        {{ (feature_type.name || "NA" )|truncate(20) }}
        <i
          v-if="edit_mode && $store.getters.has_modify_feautes_type_permissions"
          class="fa-edit-btn fa fa-edit has-text-warning"
          @click.stop="$emit('edit',feature_type)"
        ></i>
        <i
          v-if="edit_mode && $store.getters.has_modify_feautes_type_permissions"
          class="fa-delete-btn fa fa-trash has-text-danger"
          @click="deleteFeatureType()"
        ></i>
      </span>
      <span class=" is-small class_count">{{features_count[feature_type.id].count || 0}}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import _ from "lodash";
import FeatureTypeService from "@/services/feature-type.service";

export default {
  props: ["feature_type", "is_group_active", "edit_mode"],
  data() {
    return {
      isActive: true,
      featureTypeService: new FeatureTypeService()
    };
  },
  computed: {
    ...mapState([
      "draw",
      "features_count",
      "feature_type_groups",
      "feature_type_filter"
    ]),
    shortcuts() {
      let obj = {};
      for (let fg of this.feature_type_groups) {
        for (let f of fg.featureTypes) {
          obj[f.id] = [f.id, f.uid];
        }
      }
      return obj;
    }
  },
  methods: {
    ...mapMutations(["FILTER_FEATURES_BY_CLASS"]),
    toggleFeatures(class_id) {
      this.isActive = !this.isActive;
      this.FILTER_FEATURES_BY_CLASS({ class_id, active: this.isActive });
    },
    truncateStr(name) {
      return _.truncate(name || "NA", {
        length: 23,
        separator: " "
      });
    },
    applyClass(num) {
      if (this.shortcuts[num]) {
        for (let f of this.draw.getSelected().features) {
          if (f.properties.editable) {
            this.draw.setFeatureProperty(
              f.id,
              "featureTypeId",
              this.shortcuts[num][0]
            );
            this.draw.setFeatureProperty(
              f.id,
              "featureType",
              this.shortcuts[num][1]
            );
          } else {
            this.$toast.open("Can't modify, Click on edit button to modify .");
          }
        }
      }
    },
    deleteFeatureType() {
      this.$dialog.confirm({
        type: "is-danger",
        message: `Are you sure?`,
        confirmText: "Yes",
        cancelText: "No",
        onConfirm: async () => {
          this.featureTypeService
            .delete({
              uid: this.feature_type.uid
            })
            .then(res => {
              if (res.status == 204) {
                this.$emit("onDeleteFeature");
                this.$toast.open("Deleted successfully!");
              } else {
                this.$toast.open("Could not delet!!");
              }
            })
            .catch(err => {
              this.handleErrors(err);
              this.$toast.open("Something went wrong!!");
            });
        }
      });
    }
  },
  watch: {
    is_group_active: function(val) {
      this.toggleFeatures(this.feature_type.id);
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes slide-left {
  from {
    margin-left: 100%;
    width: 300%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}

.feature {
  display: flex;
  margin-left : 0.6rem;
  margin-bottom: 0.6rem;
  font-size: 14px;
  font-family: Barlow;
  color: #171e48;
  .class_name {
    cursor: pointer;
    text-align: left;
    margin-left:1.2rem; 
    font-weight: 400;
    text-transform: capitalize;
    text-decoration: line-through;
    position: relative;
    justify-content: left;
    width: 175px;
    overflow: hidden;
    z-index: 1;
    @media (max-width: 900px) {
      width: 100px;
    }
    i {
      visibility: visible;
      position: absolute;
      z-index: 1;
      right: 3px;
    }
    .fa-edit-btn {
      right: 1rem;
    }
    &.active {
      text-decoration: none;
    }
  }
  .active-feature-type {
    background: #343434;
    color: #fff;
  }
  .class_count {
    width: 85px;
    font-family: Barlow-medium;
    font-size: 16px;
    color: #171e48;
    text-align: right;
  }
}
</style>

